{
    "Omclient": "Cliente Omnicanal:",
    "OmclientAgentValidation": "Um cliente Omnichannel requer um dispositivo de agente ACD",
    "DeviceHint": "Selecione o dispositivo de supervisores para permitir os controlos de chamada baseados em browser integrados",
    "OmnichannelAgent": "Agente Omnicanal:",
    "NoneSelected": "[Nenhum selecionado]",
    "NoAssociatedDevice": "[Nenhum dispositivo associado]",
    "NoAssociatedAgent": "[Sem Agente ACD Associado]",
    "ExtensionEndpoint_PermissionsNote": "Defina as permissões de nível de acesso do utilizador.",
    "ExtensionEndpoint_CmEnvironment": "CME:",
    "ExtensionEndpoint_TelServer": "Servidor de telefonia:",
    "ExtensionEndpoint_Partition": "Partição:",
    "ExtensionEndpoint_Device": "Dispositivo:",
    "ExtensionEndpoint_AndOrAgent": "E\/ou Agente:",
    "NAME": "ExtensionDispositivo",
    "ExtensionEndpoint_Validation_Professional_Device": "Um utilizador Profissional tem de ter um dispositivo definido",
    "ExtensionEndpoint_Validation_Professional_Device_MST": "Um utilizador CXA Unused tem de ter um dispositivo definido",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent": "Um agente de Call Center tem de ter um dispositivo definido",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent_MST": "Um utilizador do CXA Premium tem de ter um dispositivo de agente definido",
    "ExtensionEndpoint_Validation_Professional_Device_MSTB": "Um usuário em tempo real deve ter um ponto de extremidade de dispositivo configurado.",
    "ExtensionEndpoint_Validation_CallCentreAgent_Agent_MSTB": "Um agente deve ter um ponto de extremidade de agente configurado."
}